/* global sure, google, InfoBox */
import Handlebars  from 'handlebars';
import { MarkerClusterer } from '@googlemaps/markerclusterer';

async function initMap(locations, single, showPlaces, type) {
	const placesTranslation = ({
		'accounting': '',
		'airport': 'Vliegveld',
		'amusement_park': 'Amusementenparken',
		'aquarium': 'Aquaria',
		'art_gallery': 'Kunsttentoonstellingen',
		'atm': 'Geldautomaten',
		'bakery': 'Bakkerij',
		'bank': 'Banken',
		'bar': 'Bars',
		'beauty_salon': 'Schoonheidssalon',
		'bicycle_store': 'Fietsenwinkels',
		'book_store': 'Boekenwinkels',
		'bowling_alley': 'Bowlingbanen',
		'bus_station': 'Bus stations',
		'cafe': 'Cafe',
		'campground': 'Kampeergelegenheid',
		'car_dealer': 'Autohandelaren',
		'car_rental': 'Autoverhuur',
		'car_repair': 'Auto monteur',
		'car_wash': 'Autowasstraat',
		'casino': 'Casino',
		'cemetery': 'Begraafplaatsen',
		'church': 'Kerken',
		'city_hall': 'Stadshuis',
		'clothing_store': 'Kledingwinkels',
		'convenience_store': 'Gemakswinkel',
		'courthouse': 'Rechtbank',
		'dentist': 'Tandarts',
		'department_store': 'Warenhuis',
		'doctor': 'Dokter',
		'electrician': 'Elektricien',
		'electronics_store': 'Elektronicawinkel',
		'embassy': 'Ambassade',
		'establishment': 'Bedrijven',
		'finance': 'Geldzaken',
		'fire_station': 'Brandweer',
		'florist': 'Bloemist',
		'food': 'Etenswaren',
		'funeral_home': 'Begrafenis thuis',
		'furniture_store': 'Meubelzaak',
		'gas_station': 'Tankstations',
		'general_contractor': 'Aannemer',
		'grocery_or_supermarket': 'Supermarkten',
		'gym': 'Sportschool',
		'hair_care': 'Kapper',
		'health': 'Sportschool',
		'hindu_temple': 'Hindoe tempel',
		'home_goods_store': 'Huishoud winkel',
		'hospital': 'Ziekenhuis',
		'insurance_agency': 'Verzekeringsmaatschappij',
		'jewelry_store': 'Juwelier',
		'laundry': 'Wasstraat',
		'lawyer': 'Advocaat',
		'library': 'Bibliotheek',
		'liquor_store': 'Slijterij',
		'local_government_office': 'Gemeentehuis',
		'locksmith': 'Slotenmaker',
		'lodging': 'Vakantie huis',
		'meal_delivery': '',
		'meal_takeaway': 'Afhaalrestaurants',
		'mosque': 'Moskee',
		'movie_rental': 'Films huren',
		'movie_theater': 'Bioscoop',
		'moving_company': 'Verhuisbedrijf',
		'museum': 'Musea',
		'night_club': 'Nachtclub',
		'painter': 'Schilder',
		'park': 'Parken',
		'parking': 'Parkeerterrein',
		'pet_store': 'Dierenwinkel',
		'pharmacy': 'Apotheek',
		'physiotherapist': 'Fysiotherapeut',
		'place_of_worship': 'Gebedshuis',
		'plumber': 'Loodgieter',
		'police': 'Politiebureau',
		'post_office': 'Postkantoor',
		'real_estate_agency': 'Makelaars',
		'restaurant': 'Restaurant',
		'roofing_contractor': 'Dakbedekkers',
		'rv_park': 'Camper sta plek',
		'school': 'Scholen',
		'secondary_school': 'Voortgezet onderwijs',
		'shoe_store': 'Schoenenwinkel',
		'shopping_mall': 'Winkelcentrum',
		'spa': 'Spa',
		'stadium': 'Stadion',
		'storage': 'Berging',
		'store': 'Winkels',
		'subway_station': 'Metrostation',
		'synagogue': 'Synagoge',
		'taxi_stand': 'Taxi standplaats',
		'train_station': 'Treinstation',
		'travel_agency': 'Reisbureau',
		'university': 'Universiteit',
		'veterinary_care': 'Veterinaire zorg',
		'zoo': 'Dierentuin',
	});

	let mapStyles;

	if (sure.mapStyles !== '') {
		mapStyles = JSON.parse(sure.mapStyles);
	} else {
		mapStyles = '';
	}

	const map = new google.maps.Map(document.getElementById('sure-map'), {
		scrollwheel: false,
		draggable: true,
		mapTypeControl: false,
		zoomControlOptions: true,
		streetViewControl: false,
		mapTypeControlOptions: {
			mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style'],
		},
		scaleControl: true,
		styles: mapStyles,
	});

	let placesMarkers = [];
	let placesService = new google.maps.places.PlacesService(map);

	function createPlacesMarkers(results, type) {
		let markers = [];
		for (let i = 0; i < results.length; i += 1) {
			const marker = createPlacesMarker(results[i], type);
			const arr = {
				'type': type,
				'marker': marker,
			};
			placesMarkers.push(arr);
			markers.push(marker);
		}

		return markers;
	}

	function removePlacesFromType(type) {
		for (let i = 0; i < placesMarkers.length; i += 1) {
			const places = placesMarkers[i];
			if (places.type === type) {
				places.marker.setMap(null);
			}
		}
	}

	function checkBounds() {
		map.fitBounds(bounds);
	}

	function disableCheckboxes() {
		const ulTypes = document.getElementById('sure-map-places');
		$('input[type=checkbox]', ulTypes).each(function () {
			$(this).attr('disabled');
		});
	}

	function enableCheckboxes() {
		var ulTypes = document.getElementById('sure-map-places');
		$('input[type=checkbox]', ulTypes).each(function () {
			$(this).removeAttr('disabled');
		});
	}

	function createPlacesMarker(place) {
		const marker = new google.maps.Marker({
			map: map,
			title: place.name,
			position: place.geometry.location,
		});

		bounds.extend(marker.position);

		const request = {
			reference: place.reference,
		};

		google.maps.event.addListener(marker, 'click', function () {
			placesService.getDetails(request, function (details, status) {
				if (status === google.maps.places.PlacesServiceStatus.OK) {
					const content = '<div class="sure-place">' +
						'<header>' +
						'<h3>' + details.name + '</h3>' +
						'</header>' +
						'<div class="place-address">' +
						details.formatted_address +
						'</div>' +
						'<footer>' +
						'<a href="tel:' + details.formatted_phone_number + '" class="place-phone">' + details.formatted_phone_number + '</a> ' +
						'</footer>' +
						'</div>';

					//Infobox options
					const infoBox = {
						content,
					};

					$('.infoBox').remove();
					const ibLabel = new InfoBox(infoBox);
					ibLabel.open(map, marker);
				}
			});
		});

		return marker;
	}

	function addPlacesFromType(type) {
		disableCheckboxes();
		placesNearbySearch(type);
	}

	function placesNearbySearch(type) {

		const request = {
			fields: ["displayName", "location", "businessStatus"],
			location: map.getCenter(),
			radius: 2500,
			type: type,
		};

		placesService.nearbySearch(request, (results, status) => {
			if (status === google.maps.places.PlacesServiceStatus.OK) {
				createPlacesMarkers(results, type);
				checkBounds();
				enableCheckboxes();
			} else {
				placesRadiusSearch(type);
				enableCheckboxes();
			}
		});
	}

	function placesRadiusSearch(type) {
		const request = {
			fields: ["displayName", "location", "businessStatus"],
			location: map.getCenter(),
			radius: 2500,
			type: type,
		};

		placesService.nearbySearch(request, (results, status) => {
			if (status === google.maps.places.PlacesServiceStatus.OK) {
				createPlacesMarkers(results, type);
				checkBounds();
				enableCheckboxes();
			}
		});
	}

	const bounds = new google.maps.LatLngBounds();

	const markers = locations.map(function (location, i) {
		const marker = new google.maps.Marker({
			position: location,
			icon: sure.googleMapsMarkerUrl,
		});

		bounds.extend(marker.position);

		if (!single) {
			google.maps.event.addListener(marker, 'click', (function (marker, i) {
				return function () {
					$.getJSON(sure.homeUrl + '/sure/api/' + type + '/object/' + locations[i].object_code + '/', function (data) {

						const source = $('#info-box').html();
						const template = Handlebars.compile(source);
						const boxContent = template(data.results);

						//Infobox options
						const infoBox = {
							content: boxContent,
						};

						$('.infoBox').remove();
						const ibLabel = new InfoBox(infoBox);
						ibLabel.open(map, marker);
						map.panTo(marker.position);
					});
				};
			})(marker, i));
		}

		return marker;
	});

	if (single && showPlaces) {
		// This is needed to set the zoom after fitbounds,
		google.maps.event.addListener(map, 'zoom_changed', function () {
			const zoomChangeBoundsListener =
				google.maps.event.addListener(map, 'bounds_changed', function () {
					if (this.getZoom() > 16 && this.initialZoom) {
						// Change max/min zoom here
						this.setZoom(16);
						this.initialZoom = false;
					}
					google.maps.event.removeListener(zoomChangeBoundsListener);
				});
		});
		map.initialZoom = true;

		// Set bounds to map
		map.fitBounds(bounds);

		let types = ['school', 'grocery_or_supermarket', 'gas_station', 'bank', 'food', 'store'];
		$.ajax({
			url: sure.ajaxURL,
			type: 'GET',
			data: {
				'action': 'google_filters',
			},
			async: false,
			success: function (response) {
				types = response;
			},
		});
		const placesList = document.getElementById('sure-map-places');

		$.each(types, function (key, val) {
			placesList.innerHTML += '<li id="list-places-maps-' + val + '">' +
				'<div class="place-name">' +
				'<label>' +
				'<input type="checkbox" name="' + val + '" class="find-places-maps" id="list-places-maps-' + val + '" />' +
				'<span>' + placesTranslation[val] + '</span>' +
				'</label>' +
				'</div>' +
				'</li>';
		});

		$('.find-places-maps').on('change', function () {
			var $this = $(this);
			var type = $this.attr('name');
			if ($this.prop('checked')) {
				addPlacesFromType(type);
			} else {
				removePlacesFromType(type);
			}
		});

	} else if (single && !showPlaces) {
		// This is needed to set the zoom after fitbounds,
		google.maps.event.addListener(map, 'zoom_changed', function () {
			const zoomChangeBoundsListener =
				google.maps.event.addListener(map, 'bounds_changed', function () {
					if (this.getZoom() > 16 && this.initialZoom) {
						// Change max/min zoom here
						this.setZoom(16);
						this.initialZoom = false;
					}
					google.maps.event.removeListener(zoomChangeBoundsListener);
				});
		});
		map.initialZoom = true;

		// Set bounds to map
		map.fitBounds(bounds);
	} else {
		// Set bounds to map
		map.fitBounds(bounds);
	}

	// Add a marker clusterer to manage the markers.
	const renderer = {
		render: ({ count, position }) =>
			new google.maps.Marker({
				icon: `${sure.googleMapsMarkerClusterUrl}1.png`,
				label: {
					text: String(count),
					color: 'rgb(0,0,0)',
					fontSize: '11px',
				},
				position,
				// adjust zIndex to be above other markers
				zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
			}),
	};
	new MarkerClusterer({
		map,
		markers,
		renderer,
	});
}

function initLocations() {
	let single = false;
	let places = false;
	let type = '';
	let url = '';
	let mapLazyload = false;
	let lazyloaded = false;
	const mapHolder = document.querySelector('.sure-map-holder');
	const mapLazyLoadButton = document.getElementById('btn-lazyload-map');
	const singleMapElement = $('.single-map');

	if (singleMapElement.length) {
		if (mapHolder && mapHolder.classList.contains('sure-map-holder--lazyload')) {
			mapLazyload = true;
		}

		type = singleMapElement.data('type');
		const $object_id = singleMapElement.data('object-id');
		url = sure.homeUrl + '/sure/api/' + type + '/object/' + $object_id + '/';
		single = true;
		if ($('.has-places').length) {
			places = true;
		}
	} else if ($('#sure-map').length) {
		const searchInput = $('input[name="sure_set_object_search"]');
		type = $('#sure-map').data('type') ?? 'wonen';
		if (searchInput.length) {
			url = sure.homeUrl + '/sure/api/' + type + '/zoeken/' + searchInput.val() + '?map=true';
		} else {
			url = sure.homeUrl + '/sure/api/' + type + '/';
		}
	}

	if (mapLazyload && mapLazyLoadButton) {
		mapLazyLoadButton.disabled = false;
		mapLazyLoadButton.addEventListener('click', function () {
			lazyloaded = true;
			mapHolder.classList.remove('sure-map-holder--lazyload');
		});
	}

	if (typeof url !== 'undefined') {
		const locations = [];

		$.getJSON(url, function (data) {
			if (data.results) {
				if ($.isArray(data.results)) {
					if (data.results.length > 0) {
						$.each(data.results, function (key, val) {
							if (val.lat && val.lng) {
								locations.push({
									lat: parseFloat(val.lat),
									lng: parseFloat(val.lng),
									object_code: val.object_code,
								});
							}
						});
					} else {
						noResults();
					}
				} else {
					if (data.results.lat && data.results.lng) {
						locations.push({
							lat: parseFloat(data.results.lat),
							lng: parseFloat(data.results.lng),
							object_code: data.results.object_code,
						});
					}
				}
				if (locations.length > 0) {
					if (mapLazyload && mapLazyLoadButton) {
						if (lazyloaded)  {
							initMap(locations, single, places, type);
							mapHolder.classList.remove('sure-map-holder--lazyload');
						} else {
							mapLazyLoadButton.addEventListener('click', function () {
								initMap(locations, single, places, type);
								mapHolder.classList.remove('sure-map-holder--lazyload');
							});
						}
					} else {
						initMap(locations, single, places, type);
					}
				} else {
					noResults();
				}
			} else {
				noResults();
			}
		});
	}
}

function noResults() {
	$('#sure-map .message').remove();
	$('#sure-map').append('<div class="message"><div class="inner">Helaas, er zijn geen objecten beschikbaar op basis van deze zoekcriteria.</div></div>');
}

function initAutoComplete() {
	const autoCompleteElement = $('#sure-auto-complete');
	if (!(autoCompleteElement.length)) {
		return;
	}

	const type = autoCompleteElement.data('type');
	autoCompleteElement.autocomplete({
		serviceUrl: sure.homeUrl + '/sure/api/' + type + '/autocomplete/',
		type: 'GET',
		paramName: '',
		dataType: 'json',
		ajaxSettings: {
			beforeSend: function (jqXHR, settings) {
				settings.url = settings.url.replace('=', '/').replace('?', '/');
			},
		},
		transformResult: function (response) {
			return {
				suggestions: $.map(response.results, function (dataItem) {
					return {
						value: dataItem.title, data: dataItem.url,
					};
				}),
			};
		},
	});
}

function initFilters() {
	$('.filter input[name="sure_type"], .filter input[name="sure_soort"], .filter input[name="sure_kantoor"]').on('change', function () {
		$(this).parents('.filter-dropdown').find('input[type="checkbox"]').prop('disabled', true);
		if ($(this).prop('checked')) {
			$(this).parents('.sub-filter').find('input[type="checkbox"]').prop('disabled', false);
		}
	});

	$('.filter input[type="checkbox"]').each(function () {
		if ($(this).prop('checked')) {
			$(this).parents('.sub-filter').addClass('open');
		}
	});
}

function initAjaxFilters() {
	if ($('input[name="sure_set_map_search"]').length) {
		let $map = true;
		const filtersElement = $('.sure-filters');
		const type = filtersElement.data('type');
		filtersElement.on('change', function (e) {
			e.preventDefault();

			const $data = $(this).serializeObject();

			$.ajax({
				url: sure.ajaxURL,
				type: 'POST',
				dataType: 'html',
				data: {
					'action': 'search_query_handler',
					'data': $data,
					'map': $map,
				},
				success: function (response) {
					var data = JSON.parse(response);
					window.history.pushState(null, null, sure.homeUrl + '/' + type + '/kaart/zoeken/' + data.search_query);
					if (data.results) {
						if (data.results.length > 0) {
							var locations = [];
							$.each(data.results, function (key, val) {
								if (val.lat && val.lng) {
									locations.push({
										lat: parseFloat(val.lat),
										lng: parseFloat(val.lng),
										object_code: val.object_code,
									});
								}
							});
							initMap(locations, false, false, type);

						} else {
							noResults();
						}
					} else {
						noResults(); 
					}
				},
			});

			return false;
		});
	}
}

$(document).ready(function () {
	initLocations();
	initAutoComplete();
	initFilters();
	initAjaxFilters();
});
